<!-- Container to display spinner in the middle of the page -->
<template>
  <div class="spinner-container">
    <Spinner />
  </div>
</template>

<script>
import Spinner from './Spinner.vue';

export default {
  name: 'SpinnerContainer',
  components: { Spinner },
};
</script>
